import React from 'react';
import PropTypes from 'prop-types';
import get from "lodash/get";

import Heading from '../sharedComponents/Heading';
import RecommendationsListCard from './RecommendationsListCard'

const propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    errorMsg: PropTypes.string,
    onCardSelect: PropTypes.func.isRequired,
    recommendations: PropTypes.object,
    type: PropTypes.string.isRequired,
    windowWidth: PropTypes.number
};

export const RecommendationsList = (props) => {
    const recommendationResults = get(props.recommendations, 'results', []);
    const highlightClass = '';

    return (
        <div className=''>
            <div className='recommendation-list--outer'>
                <Heading headingLevel={2} appearance="h6" className="rec-aside-body-heading mb-1 px-2">
                    Campgrounds Nearby
                </Heading>

                <div className='recommendation-list'>
                    {recommendationResults && recommendationResults.map((item, index) => {
                        if (index < 4) {
                            return (
                                <RecommendationsListCard
                                    key={item.entity_id}
                                    index={index}
                                    type={props.type}
                                    startDate={props.startDate}
                                    endDate={props.endDate}
                                    dynamicClass={highlightClass}
                                    item={item}
                                    layout='campground'
                                    nth={index}
                                    onCardSelect={props.onCardSelect}
                                    val={highlightClass}
                                    windowWidth={props.windowWidth} />
                            );
                        }
                        return '';
                    })}
                </div>

                {/*
                // NOTE: This is commented out on purpose for now
                // since it needs to be un-commented-out before merge.
                <FlexRow justifyContent="end">
                    <a href="/">
                    <span className="recommendation-list--arrow-text">
                        View all
                    </span>
                        <span className="recommendation-list--arrow">
                        <IconArrowForward size="sm" />
                    </span>
                    </a>
                </FlexRow>
                */}

            </div>
        </div>
    );
};

RecommendationsList.propTypes = propTypes;

export default RecommendationsList;
